import Slider from 'react-slick';
import { styled } from 'styled-components';
import { Row, Col } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';
import ScrollAnimation from 'react-animate-on-scroll';

import { PrimaryButton } from './Button';
import Link from './Link';

import img_case_01 from '../assets/cases/img_case_01.jpg';
import img_case_02 from '../assets/cases/img_case_02.jpg';
import img_case_03 from '../assets/cases/img_case_03.jpg';
import img_case_04 from '../assets/cases/img_case_04.jpg';
import img_case_05 from '../assets/cases/img_case_05.jpg';
import img_case_06 from '../assets/cases/img_case_06.jpg';
import img_case_07 from '../assets/cases/img_case_07.jpg';
import img_case_08 from '../assets/cases/img_case_08.jpg';
import { VIDEO_CASE, CONSULT_SURVEY, CASE_ARTICLE_1, CASE_ARTICLE_8 } from '../data/url';

const CaseWrapper = styled.div`
    padding: 0px 32px;

    @media screen and (max-width: 768px) {
        padding: 0px 20px;
    }
`;

const Header = styled(Row)`
    color: #1385C8;
    font-size: 56px;
    font-weight: bold;
    line-height: 76px;
    width: 100%;
    justify-content: center;
    margin-bottom: 60px;
    text-align: center;

    @media screen and (max-width: 768px) {
        margin-bottom: 40px;
        font-size: 36px;
        line-height: 48px;
    }
`;

const CarouselWrapper = styled(Row)`
    margin-bottom: 160px;

    @media screen and (max-width: 768px) {
        margin-bottom: 100px;
    }
`;

const CarouselItem = styled.div`
    display: flex !important;
    flex-direction: column;
    align-items: center;

    div {
        width: 80%;
        text-align: left;
        font-size: 18px;
        line-height: 28px;
        margin-top: 10px;
    }
`;

const CustomArrow = styled.div<{ style: React.CSSProperties }>`
    ${({ style }) => ({...style})}
    background-color: #45B9AE;
    width: 40px; 
    height: 40px;
    border-radius: 30px;
    text-align: center;
    font-size: 20px;
    color: #FFFFFF;
    display: flex !important;
    justify-content: center;
    align-items: center;
    z-index: 20;
    
    &:before {
        display: none; 
    }

    &:hover {
        color: #FFFFFF;
        background: #45B9AE;
    }
`;

const VideoWrapper = styled.div`
    width: 1024px;
    height: 576px;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
        width: 100%;
        height: 100%;
        aspect-ratio: 16/9;
    }
`;

const Case = () => {

    const PrevArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, left: '-15px' }} >
            <LeftOutlined/>
        </CustomArrow>
    );

    const NextArrow = (props: {
        className?: string,
        onClick?: React.MouseEventHandler<HTMLDivElement>,
        style?: React.CSSProperties
    }) => (
        <CustomArrow className={props.className} onClick={props.onClick} style={{ ...props.style!, right: '-15px' }} >
            <RightOutlined/>
        </CustomArrow>
    );

    return (
        <CaseWrapper id='case'>
            <ScrollAnimation animateIn='fadeIn' animateOnce>
                <Header>企業案例</Header>
                <CarouselWrapper>
                    <Col md={24} sm={0} xs={0}>
                    <Slider
                        slidesToShow={2}
                        slidesToScroll={1}
                        infinite={true}
                        dots={false}
                        prevArrow={<PrevArrow/>}
                        nextArrow={<NextArrow/>}
                    >
                        <CarouselItem>
                            <Link newTab href={CASE_ARTICLE_1} style={{ width: '80%' }}>
                                <img src={img_case_01} alt='img_case_01' style={{ width: '100%' }} />
                            </Link>
                            <div>機械製造業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_02} alt='img_case_02' style={{ width: '80%' }} />
                            <div>資訊軟體服務業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_03} alt='img_case_03' style={{ width: '80%' }} />
                            <div>百貨零售精品業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_04} alt='img_case_04' style={{ width: '80%' }} />
                            <div>政府單位</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_05} alt='img_case_05' style={{ width: '80%' }} />
                            <div>證券及期貨業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_06} alt='img_case_06' style={{ width: '80%' }} />
                            <div>電子設備製造業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_07} alt='img_case_07' style={{ width: '80%' }} />
                            <div>教育業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={CASE_ARTICLE_8} style={{ width: '80%' }}>
                                <img src={img_case_08} alt='img_case_08' style={{ width: '100%' }} />
                            </Link>
                            <div>工程業</div>
                        </CarouselItem>
                    </Slider>
                    </Col>
                    <Col md={0} sm={24} xs={24}>
                    <Slider
                        slidesToShow={1}
                        slidesToScroll={1}
                        infinite={true}
                        dots={false}
                        prevArrow={<PrevArrow/>}
                        nextArrow={<NextArrow/>}
                    >
                        <CarouselItem>
                            <Link newTab href={CASE_ARTICLE_1} style={{ width: '80%' }}>
                                <img src={img_case_01} alt='img_case_01' style={{ width: '100%' }} />
                            </Link>
                            <div>機械製造業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_02} alt='img_case_02' style={{ width: '80%' }} />
                            <div>資訊軟體服務業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_03} alt='img_case_03' style={{ width: '80%' }} />
                            <div>百貨零售精品業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_04} alt='img_case_04' style={{ width: '80%' }} />
                            <div>政府單位</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_05} alt='img_case_05' style={{ width: '80%' }} />
                            <div>證券及期貨業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_06} alt='img_case_06' style={{ width: '80%' }} />
                            <div>電子設備製造業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <img src={img_case_07} alt='img_case_07' style={{ width: '80%' }} />
                            <div>教育業</div>
                        </CarouselItem>
                        <CarouselItem>
                            <Link newTab href={CASE_ARTICLE_8} style={{ width: '80%' }}>
                                <img src={img_case_08} alt='img_case_08' style={{ width: '100%' }} />
                            </Link>
                            <div>工程業</div>
                        </CarouselItem>
                    </Slider>
                    </Col>
                </CarouselWrapper>
            </ScrollAnimation>
            <ScrollAnimation animateIn='fadeIn' animateOnce>
                <Header>Workute 企業用戶實際導入分享</Header>
                <VideoWrapper>
                    <ReactPlayer url={VIDEO_CASE} controls width='100%' height='100%' />
                </VideoWrapper>
                <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '80px' }}>
                    <PrimaryButton newTab href={CONSULT_SURVEY} content='立即洽詢' width='120px' />
                </Row>
            </ScrollAnimation>
        </CaseWrapper>
    );
};

export default Case;
